export interface Submission {
  id: string;
  eventId: string;
  creatorName: string;
  creatorAvatar: string;
  imageUrl: string;
  prompt: string;
  likes: number;
  views: number;
  comments: number;
}

export const dummySubmissions: Submission[] = [
  {
    id: "sub1",
    eventId: "1",
    creatorName: "Alice",
    creatorAvatar: "https://i.pravatar.cc/150?u=alice",
    imageUrl:
      "https://images.unsplash.com/photo-1620712943543-2858200f7426?w=500&auto=format&fit=crop&q=60",
    prompt: "A robot painting a masterpiece in a futuristic studio.",
    likes: 1200,
    views: 15000,
    comments: 45,
  },
  {
    id: "sub2",
    eventId: "1",
    creatorName: "Bob",
    creatorAvatar: "https://i.pravatar.cc/150?u=bob",
    imageUrl:
      "https://images.unsplash.com/photo-1555949963-ff9fe0c870eb?w=500&auto=format&fit=crop&q=60",
    prompt: "A neon-lit city street in the year 3030.",
    likes: 950,
    views: 12000,
    comments: 32,
  },
  {
    id: "sub3",
    eventId: "1",
    creatorName: "Charlie",
    creatorAvatar: "https://i.pravatar.cc/150?u=charlie",
    imageUrl:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?w=500&auto=format&fit=crop&q=60",
    prompt: "The inner workings of a quantum computer, visualized.",
    likes: 2100,
    views: 25000,
    comments: 88,
  },
  // Add more submissions for event 1 and other events if needed
];
